export function isArrayEqual(firstArray, secondArray) {
  return (
    firstArray.length === secondArray.length && firstArray.every((element, index) => element === secondArray[index])
  );
}
export function isArrayEqualUnsorted(firstArray = [], secondArray = []) {
  return firstArray.length === secondArray.length && firstArray.every(element => secondArray.includes(element));
}

export function sortArrayBasedOnArray(arrayToBeSorted, sortingArray) {
  return arrayToBeSorted.sort((a, b) => sortingArray.indexOf(a) - sortingArray.indexOf(b));
}

export function getIntersection(fooArray = [], barArray = []) {
  return fooArray.filter(x => barArray.includes(x));
}

export function getUnion(fooArray = [], barArray = []) {
  return [...new Set([...fooArray, ...barArray])];
}

export function getUnique(fooArray = []) {
  return [...new Set(fooArray)];
}

export function getDifference(fooArray = [], barArray = []) {
  return fooArray.filter(x => !barArray.includes(x));
}

export function chunkArray(myArray, chunk_size) {
  let arrayLength = myArray.length;
  let tempArray = [];
  let myChunk = [];
  for (let index = 0; index < arrayLength; index += chunk_size) {
    myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }

  return tempArray;
}

export function toggleElement(value, myArray = []) {
  return myArray.includes(value) ? getDifference(myArray, [value]) : getUnion(myArray, [value]);
}



// WEBPACK FOOTER //
// ./src/Utils/ArrayUtils.js